<template>
  <div>
    <q-btn
      :label="$ts('words.upload')"
      color="positive"
      unelevated
      rounded
      icon="upload"
      @click="triggerUploader()"
    ></q-btn>
    <basic-modal :refs="uuid" :title="title">
      <template slot="modal-data" slot-scope="props">
        <div class="row q-col-gutter-lg justify-end">
          <div class="col-12">
            <Uploader
              :url="api.productDocumentTemplateUpload"
              :multiple="false"
              :upload-callback="uploaded"
              :additional-fields="[...additionalFields, ...[{ name: 'type', value: typeId }]]"
              uploader-file-type="product_template"
              custom-error-att="file"
            />
          </div>
          <div class="col-12">
            <Info stacked :message="$ts('message.info.downloadTemplate')">
              <template slot="bottom-actions">
                <q-btn
                  size="sm"
                  outline
                  rounded
                  unelevated
                  color="positive"
                  :label="$ts('words.downloadTemplate')"
                  icon="download"
                  @click="downloadTemplateFile"
                ></q-btn>
              </template>
            </Info>
          </div>
        </div>
      </template>
    </basic-modal>
  </div>
</template>
<script>
import { api } from '../../../api'
import masterData from 'src/utils/mappings/masterData'
import { openURL } from 'quasar'
import { mapActions } from 'vuex'
import { Uploader } from 'src/application/global/components'
import { uid } from 'quasar'

export default {
  name: 'ProductUploaderModel',
  components: {
    Uploader,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
      validator: x => {
        return (
          [
            'itoken-product-entitlement',
            'itoken-token-product-entitlement',
            'esac-product-entitlement',
            'esac-exception-product',
          ].indexOf(x) !== -1
        )
      },
    },
    additionalFields: {
      type: Array,
      default: () => [],
    },
    delay: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      typeId: null,
      api,
      uuid: uid(),
    }
  },
  computed: {
    ...masterData({
      getMasterMapping: {
        mappings: {
          'masterKey.PRODUCT_TEMPLATE_TYPE': {
            esacProductEntitlementID: 'masterData.ESAC_PRODUCT_ENTITLEMENT',
            esacExceptionProductID: 'masterData.ESAC_EXCEPTION_PRODUCT',
            iTokenProductEntitlementID: 'masterData.ITOKEN_PRODUCT_ENTITLEMENT',
            iTokenTokenProductEntitlementID: 'masterData.ITOKEN_TOKEN_PRODUCT_ENTITLEMENT',
          },
        },
      },
    }),
  },
  async mounted() {
    setTimeout(async () => {
      await this.getMasterMapping()
      if (this.type === 'itoken-product-entitlement') {
        this.typeId = this.iTokenProductEntitlementID
      }
      if (this.type === 'itoken-token-product-entitlement') {
        this.typeId = this.iTokenTokenProductEntitlementID
      }
      if (this.type === 'esac-product-entitlement') {
        this.typeId = this.esacProductEntitlementID
      }
      if (this.type === 'esac-product-entitlement') {
        this.typeId = this.esacProductEntitlementID
      }
      if (this.type === 'esac-exception-product') {
        this.typeId = this.esacExceptionProductID
      }
    }, this.delay)
  },
  methods: {
    ...mapActions(['downloadProductsTemplateFileAction']),
    downloadTemplateFile() {
      this.downloadProductsTemplateFileAction({ type: this.typeId }).then(res => {
        let downloadLink = this.$helpers.getValue(res, 'download_link')
        if (downloadLink) {
          openURL(downloadLink)
        }
      })
    },
    triggerUploader() {
      this.openCloseModal({ name: this.uuid, status: true })
    },
    uploaded(file, res) {
      let uploadStatus = this.$helpers.getValue(res, 'status')
      if (uploadStatus && (uploadStatus === 200 || uploadStatus === 422)) {
        let responseData = JSON.parse(this.$helpers.getValue(res, 'response'))
        if (responseData) {
          this.$emit('uploaded', responseData.data)
        }
      }
      this.openCloseModal({ name: this.uuid, status: false })
    },
  },
}
</script>
